<nav *ngIf="visible" class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-xl my-4 d-flex justify-content-between">
    <div class="section-logo">
      <a class="navbar-brand" href="/">
        <img
          class="logo"
          src="https://cdn.estore5s.com/asset/estore-logo-transparent.png"
          alt="estore-logo"
          width="200px"
        />
      </a>
    </div>
    <div class="section-links">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item mx-2">
          <a routerLink="/homepage" class="nav-link" routerLinkActive="active"
            >How to?</a
          >
          <div
            routerLink="/homepage"
            class="border-empty"
            routerLinkActive="border-active"
          ></div>
        </li>
        <!-- <li class="nav-item mx-2">
                    <a routerLink="/pricing-plan" class="nav-link" routerLinkActive="active">Subscription</a>
                    <div routerLink="/pricing-plan" class="border-empty" routerLinkActive="border-active"></div>
                </li> -->
        <!--<li class="nav-item mx-2">
                    <a routerLink="/billing-history" class="nav-link" routerLinkActive="active">History</a>
                    <div routerLink="/billing-history" class="border-empty" routerLinkActive="border-active"></div>
                </li>
                <li class="nav-item mx-2" *ngIf="canInDashboard">
                    <a (click)="signOn()" routerLink="/dashboard/overview" class="nav-link" routerLinkActive="active">Dashboard</a>
                    <div routerLink="/dashboard/overview" class="border-empty" routerLinkActive="border-active"></div>
                </li>
                <li class="nav-item mx-2">
                    <a routerLink="/faq" class="nav-link" routerLinkActive="active">FAQ</a>
                    <div routerLink="/faq" class="border-empty" routerLinkActive="border-active"></div>
                </li>-->
      </ul>
    </div>
    <div class="row section-cta">
      <!--<button class="btn btn-light btn-search mt-2">
                <img class="search-icon" src="../../assets/icon/search-icon.png" alt="search">
            </button>
            <ul class="navbar-nav me-auto mb-2 mb-lg-0 mx-3 mt-2">
                <li class="nav-item mx-2">
                    <a class="nav-link my-store-link" href="#">My Store</a>
                </li>
            </ul>-->
      <button
        (click)="goToSignUp()"
        class="btn btn-outline-primary rounded-pill"
      >
        Setup New Store
      </button>
    </div>
    <div class="section-menu">
      <button (click)="toggleNav()" class="btn btn-light">
        <img
          class="menu-icon"
          src="../../assets/icon/menu-outline.svg"
          alt="menu"
        />
      </button>
    </div>
  </div>
</nav>

<nav [@collapse]="!isMobile" class="mobile-nav d-flex flex-column">
  <div class="section-links">
    <ul class="navbar-nav">
      <li (click)="toggleNav()" class="nav-item mx-auto">
        <a routerLink="/homepage" class="nav-link" routerLinkActive="active"
          >How to?</a
        >
        <div
          routerLink="/homepage"
          class="border-empty"
          routerLinkActive="border-active"
        ></div>
      </li>
    </ul>
  </div>
  <div
    *ngIf="isSectionCta"
    class="row section-cta d-flex justify-content-center mt-4"
  >
    <button class="btn btn-light btn-search mt-2">
      <img
        class="search-icon"
        src="../../assets/icon/search-icon.png"
        alt="search"
      />
    </button>
    <ul class="navbar-nav me-auto mb-2 mb-lg-0 mx-3 mt-2">
      <li class="nav-item mx-2">
        <a class="nav-link my-store-link" href="#">My Store</a>
      </li>
    </ul>
    <button class="btn btn-outline-primary rounded-pill">
      Setup New Store
    </button>
  </div>
</nav>
